import type { IntakeQuestion } from "../../registry/types";

/**
 * Intake questions shown in the blocking modal before the widget appears.
 * Keep to ~3 — every question is friction. All single-select for v1.
 *
 * (Monthly chargeback volume isn't asked here — we already pull it from
 * the Shopify integration.)
 *
 * Copy is placeholder; wording will be polished by product/UX before launch.
 */
export const DISPUTES_INTAKE_QUESTIONS: IntakeQuestion[] = [
  {
    id: "current_process",
    type: "single-select",
    prompt: "How are you handling chargebacks today?",
    required: true,
    options: [
      { value: "nothing", label: "Not handling them" },
      { value: "manual", label: "Manually responding to each one" },
      { value: "agency", label: "Using an outside agency" },
      { value: "competitor", label: "Using another chargeback tool" },
    ],
  },
  {
    id: "primary_goal",
    type: "single-select",
    prompt: "What outcome matters most to you?",
    required: true,
    options: [
      { value: "recover_revenue", label: "Recover lost revenue" },
      { value: "save_time", label: "Save time on responses" },
      { value: "automate_fully", label: "Automate the whole process" },
    ],
  },
];
